import DropDown from './components/Dropdown.vue';
import SearchDropDown from './components/SearchDropDown.vue';
import InputPlus from './components/InputPlus.vue';
import { ValidationProvider } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component('search-drop-down', SearchDropDown);
    Vue.component('drop-down', DropDown);
    Vue.component('input-plus', InputPlus);
    Vue.component('ValidationProvider', ValidationProvider);
    Vue.component('ValidationObserver', ValidationObserver);
  },
};

export default GlobalComponents;
